(ns hai.tasks.urgency
  "The task urgency vocabulary: the three `:task.urgency/*` idents and their
   display labels, shared by every surface that sets or groups tasks by
   urgency.")

(def options
  "Ordered urgency choices, most-to-least urgent."
  [{:value :task.urgency/now   :label "Now"}
   {:value :task.urgency/next  :label "Next"}
   {:value :task.urgency/later :label "Later"}])
